import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/$tenantId/')({
  // component: () => <Navigate to="./recipes" />,
});
